import axios from "./axios";

const BASE = "/company/settings/integrations/webhooks";

export function fetchCompanyWebhooks() {
  return axios.get(BASE).then((res) => res.data);
}

export function createCompanyWebhook(payload) {
  return axios.post(BASE, payload).then((res) => res.data);
}

export function updateCompanyWebhook(id, payload) {
  return axios.patch(`${BASE}/${id}`, payload).then((res) => res.data);
}

export function deleteCompanyWebhook(id) {
  return axios.delete(`${BASE}/${id}`).then((res) => res.data);
}

export function rollCompanyWebhookKey(id) {
  return axios.post(`${BASE}/${id}/roll_key`).then((res) => res.data);
}

export function fetchCompanyWebhookDeliveries(id) {
  return axios.get(`${BASE}/${id}/deliveries`).then((res) => res.data);
}

export function testCompanyWebhook(id) {
  return axios.post(`${BASE}/${id}/test`).then((res) => res.data);
}
